import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: center;
  box-shadow: 0 0.2rem 0.8rem 0 rgba(50, 50, 50, 0.04);
  background-color: ${p => p.transparent ? 'transparent' : p.theme.primaryColor};
  z-index: 999;
  ${media.small`
    justify-content: space-between;
  `};
`;

export const NavWrapper = styled.nav`
  position: relative;
  width: ${props => props.theme.container.wider.width};
  height: 7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 2.8rem;
  ${media.medium`
    width: 100%;
    flex-direction: column;
  `};
  ${media.small`
    max-width: 100%;
    height: 6rem;
    align-items: flex-start;
  `};
`;

export const Name = styled.aside`
  color: ${p => p.theme.tertiaryColor};
  font-weight: 600;
  letter-spacing: 0.2rem;
  font-size: 2.8rem;
  padding: 2rem;
  ${media.medium`
    padding: 2rem 2rem 0;
  `};
  ${media.small`
    text-overflow: clip;
    min-height: 6rem;
    max-width: 35rem;
    overflow: hidden;
    font-size: 1.8rem;
    text-align: left;
    white-space: nowrap;
    padding-right: 0;
  `};
  ${media.smaller`
    font-size: 2rem;
    max-width: 34rem;
  `};
`;

export const NavSection = styled.div`
  color: ${p => p.transparent ? p.theme.primaryColor : p.theme.quaternaryColor};
  font-size: 2rem;
  display: flex;
  align-items: center;
  ${media.small`
    display: block;
    background-color: ${p => p.theme.primaryColor};
    visibility: ${p => p.isOpen ? 'visible' : 'hidden'};
    flex-direction: column;
    transition: visibility 0s, opacity 0.3s linear;
    opacity: ${p => p.isOpen ? 1 : 0};
    padding: 0 0 1rem 0;
    width: 100%;
  `};
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: ${p => p.transparent ? p.theme.primaryColor : p.theme.quaternaryColor};
  padding: ${p => p.theme.padding};
  &:hover {
    color: ${p => p.transparent ? p.theme.primaryColor : p.theme.secondaryColor};
  }

  ${media.small`
    margin: 0 1rem;
    color: ${p => p.theme.quaternaryColor};
  `};
`;

export const MenuIconWrapper = styled.div`
  display: none;
  width: 4rem;
  padding-right: 2rem;
  height: 6rem;
  ${media.small`
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
  `};
`;

export const MenuIcon = styled.div`
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
`;



// WEBPACK FOOTER //
// ./components/LightHeader/NavHeader.style.js